import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, DEFAULT_LINK_ID, WIDGET_MEDIA_BORDER_RADIUS } from '../../../utils/constants/Constants.js';
import { styled, Grid } from '@mui/material';
import { BrandclubVideo } from '../BrandclubVideo.js';
import { ConditionalWrapper } from '../../../HOCs/ConditionalWrapper/index.js';
import { GenericContainer } from '../GenericContainer.js';
import React from 'react';
import { BrandClubBorderButton } from '../../BrandclubButton/index.js';

var _a, _b, _c, _d, _e;
var BrandclubSideWidgetContainer = styled(GenericContainer, {
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: fullWidth ? 0 : '5%',
            paddingRight: fullWidth ? 0 : '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var ContentWrapper = styled(Grid, {
    shouldForwardProp: function (prop) { return !['fullWidth', 'side', 'columnReverse'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var side = _a.side, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, columnReverse = _a.columnReverse;
    return _b = {
            maxWidth: fullWidth ? '100%' : DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
            width: '100%',
            flexDirection: 'row',
            gap: '10px',
            padding: '0 0%'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            gap: '15px',
            flexDirection: columnReverse !== undefined
                ? columnReverse
                    ? 'column-reverse'
                    : 'column'
                : side === 'imageLeft'
                    ? 'column'
                    : 'column-reverse',
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
            maxWidth: 500,
        },
        _b;
});
var VideoContainer = styled('div')((_a = {
        boxSizing: 'border-box',
        width: '50%',
        aspectRatio: '1/1',
        maxWidth: '100%',
        maxHeight: '100%'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        aspectRatio: 'unset',
        width: '100%',
    },
    _a));
var ImageContainer = styled('div')((_b = {
        boxSizing: 'border-box',
        width: '50%',
        aspectRatio: '1/1'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        width: '100%',
    },
    _b['.img_wrapper'] = {
        maxHeight: '100%',
        height: '100%',
        '.side_img': {
            height: '100%',
            textAlign: 'center',
            img: {
                height: '100%',
                maxWidth: '100%',
            },
        },
    },
    _b));
var TextContainer = styled('div')((_c = {
        boxSizing: 'border-box',
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        width: '100%',
    },
    _c['.textwrapper'] = {
        maxWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    _c['.title'] = (_d = {
            fontSize: 50,
            fontWeight: 700,
            lineHeight: 1.2
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
        },
        _d),
    _c['.subtitle'] = (_e = {
            marginTop: 20,
            lineHeight: 1.6,
            fontSize: 20,
            fontWeight: 500
        },
        _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            marginTop: 5,
            fontSize: 16,
            textAlign: 'center',
            padding: '0 20px',
        },
        _e),
    _c));
var RichContentSide = function (_a) {
    var imageUrl = _a.imageUrl, _b = _a.linkTo, linkTo = _b === void 0 ? '' : _b, LinkComponent = _a.LinkComponent, _c = _a.imageStyle, imageStyle = _c === void 0 ? {} : _c;
    return (React.createElement(ImageContainer, null,
        React.createElement("div", { className: "img_wrapper" },
            React.createElement(ConditionalWrapper, { condition: !linkTo.startsWith(DEFAULT_LINK_ID), wrapper: function (children) { return (React.createElement(LinkComponent, { to: linkTo, style: { width: '100%', height: '100%' } }, children)); } },
                React.createElement("div", { className: "side_img", style: __assign({}, imageStyle) },
                    React.createElement("img", { loading: "lazy", src: imageUrl, style: { borderRadius: WIDGET_MEDIA_BORDER_RADIUS }, alt: imageUrl }))))));
};
var TextContentSide = function (_a) {
    var buttonText = _a.buttonText, title = _a.title, subtitle = _a.subtitle, _b = _a.linkTo, linkTo = _b === void 0 ? '' : _b, LinkComponent = _a.LinkComponent;
    var hasButton = buttonText && linkTo;
    return (React.createElement(TextContainer, null,
        React.createElement("div", { className: "textwrapper" },
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "subtitle" }, subtitle),
            hasButton && (React.createElement(LinkComponent, { to: linkTo, style: { marginTop: 20 } },
                React.createElement(BrandClubBorderButton, { width: "content-fit", buttonText: buttonText, 
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: function () { } }))))));
};
var VideoSide = function (_a) {
    var _b = _a.video, video = _b === void 0 ? '' : _b, coverImage = _a.coverImage, _c = _a.videoContainerStyle, videoContainerStyle = _c === void 0 ? {} : _c;
    return (React.createElement(VideoContainer, { style: videoContainerStyle },
        React.createElement(BrandclubVideo, { videoUrl: video, posterUrl: coverImage })));
};
var SingleSideWidget = function (_a) {
    var type = _a.type, video = _a.video, coverImage = _a.coverImage, imageUrl = _a.imageUrl, imageLink = _a.imageLink, buttonLink = _a.buttonLink, buttonText = _a.buttonText, title = _a.title, subtitle = _a.subtitle, _b = _a.imageStyle, imageStyle = _b === void 0 ? {} : _b, _c = _a.videoContainerStyle, videoContainerStyle = _c === void 0 ? {} : _c, LinkComponent = _a.LinkComponent;
    if (type === 'image') {
        return (React.createElement(RichContentSide, { imageUrl: imageUrl, linkTo: imageLink === null || imageLink === void 0 ? void 0 : imageLink.id, LinkComponent: LinkComponent, imageStyle: imageStyle }));
    }
    else if (type === 'text') {
        return (React.createElement(TextContentSide, { title: title, subtitle: subtitle, buttonText: buttonText, linkTo: buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.id, LinkComponent: LinkComponent }));
    }
    else if (type === 'video') {
        return React.createElement(VideoSide, { video: video, coverImage: coverImage, videoContainerStyle: videoContainerStyle });
    }
    return null;
};
var BrandclubSideWidget = function (_a) {
    var leftSideProps = _a.leftSideProps, rightSideProps = _a.rightSideProps, LinkComponent = _a.LinkComponent, fullWidth = _a.fullWidth, columnReverse = _a.columnReverse;
    var side = 'imageRight';
    if (rightSideProps.type === 'text') {
        side = 'imageLeft';
    }
    return (React.createElement(BrandclubSideWidgetContainer, { fullWidth: fullWidth || false },
        React.createElement(ContentWrapper, { fullWidth: fullWidth, container: true, wrap: "nowrap", side: side, columnReverse: columnReverse },
            React.createElement(SingleSideWidget, __assign({}, leftSideProps, { LinkComponent: LinkComponent })),
            React.createElement(SingleSideWidget, __assign({}, rightSideProps, { LinkComponent: LinkComponent })))));
};

export { BrandclubSideWidget as default };
//# sourceMappingURL=index.js.map
